import { ModelCompareV4 } from "@ubnt/store.core/lib/components/ModelCompareV4/ModelCompareV4";
import { ButtonGroup } from "@ubnt/store.core/lib/components/ModelCompareV4/ProductList/components/ButtonGroup";
import React from "react";
import { ModelCompareWithButtonGroupProps } from "./ModelCompareWithButtonGroup.types";
import { MODEL_COMPARE_STICK_OFFSET_CORRECTION } from "util/constants";

export const ModelCompareWithButtonGroup = ({
  tabItems,
  activeTab,
  onTabClick,
  externalSelectedProducts,
  externalSetSelectedProducts,
  showBuyButton,
  section,
}: ModelCompareWithButtonGroupProps) => {
  return (
    <>
      {!!tabItems.length && (
        <ButtonGroup
          items={tabItems}
          onClick={onTabClick}
          activeButton={activeTab}
        />
      )}
      <ModelCompareV4
        showBuyButton={showBuyButton ?? false}
        section={{ ...section, showProductGroups: !tabItems.length }}
        headerStickOffset={({ maxImageHeight }) =>
          maxImageHeight + MODEL_COMPARE_STICK_OFFSET_CORRECTION
        }
        selectedProducts={externalSelectedProducts}
        setSelectedProducts={externalSetSelectedProducts}
      />
    </>
  );
};
